import React from 'react';
import "../styles.css";

const Footer = () => {
  return (
    <div className="footer">
      <p>Copyright © 2025 Tickle Right All Rights Reserved</p>
    </div>
  );
};

export default Footer;